import React from 'react';

// Corner registration marks like the ones used in real print proofing
const RegistrationMark = ({ className = '', size = 40 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      {/* CMYK quadrants */}
      <circle cx="20" cy="20" r="14" stroke="#050F2E" strokeWidth="1" fill="none" />
      <path d="M20 6 L20 34" stroke="#050F2E" strokeWidth="1" />
      <path d="M6 20 L34 20" stroke="#050F2E" strokeWidth="1" />
      <path d="M20 6 A14 14 0 0 1 34 20 L20 20 Z" fill="#00B7C7" />
      <path d="M34 20 A14 14 0 0 1 20 34 L20 20 Z" fill="#E5007E" />
      <path d="M20 34 A14 14 0 0 1 6 20 L20 20 Z" fill="#FFD700" />
      <path d="M6 20 A14 14 0 0 1 20 6 L20 20 Z" fill="#050F2E" />
    </svg>
  );
};

export default RegistrationMark;
